(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("infinite-scroll", [], factory);
	else if(typeof exports === 'object')
		exports["infinite-scroll"] = factory();
	else
		root["infinite-scroll"] = factory();
})(this, function() {
return 